import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { environment } from '@se-po/shared-environments'
import { SharedUiAddGuardianModule } from '@se-po/shared-ui-add-guardian'
import { SharedUiGuardianInviteInfoModule } from '@se-po/shared-ui-guardian-invite-info'
import { seAnalyticsConfig, SeAnalyticsModule } from 'se-analytics'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeHeaderModule } from 'se-fe-header'
import { seFeIconClose, SeFeIconModule, seFeIconSpotFamily } from 'se-fe-icon'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFeModalModule } from 'se-fe-modal'
import { SeFePopoverModule } from 'se-fe-popover'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTranslationsModule } from 'se-fe-translations'
import { AddGuardianModalComponent } from './add-guardian-modal/add-guardian-modal.component'
import { InviteReviewComponent } from './invite-review/invite-review.component'
import { InviteComponent } from './invite/invite.component'

@NgModule({
  imports: [
    CommonModule,
    SeAnalyticsModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeHeaderModule,
    SeFeIconModule.include([seFeIconClose, seFeIconSpotFamily]),
    SeFeLinkModule,
    SeFeModalModule,
    SeFePopoverModule,
    SeFeToastModule,
    SeFeTranslationsModule,
    SharedUiAddGuardianModule,
    SharedUiGuardianInviteInfoModule
  ],
  providers: [{
    provide: seAnalyticsConfig,
    useValue: {
      platProp: 'ngin',
      currentEnv: environment.name
    }
  }],
  declarations: [
    AddGuardianModalComponent,
    InviteComponent,
    InviteReviewComponent
  ],
  exports: [AddGuardianModalComponent],
})
export class SePersonaPickerFeatureAddGuardianModalModule {}
